import React, {Component, Fragment} from "react";
import logo_svg from "../../../assets/img/logo.svg";

class LogoPageFull extends Component{
	render() {
		return (
			<Fragment>
				<div className={'w-100 margin-5-B margin-5-T'} align={'center'}>
					<img src={logo_svg} alt="logo_svg" className={'w-220-px h-auto'}/>
				</div>
			</Fragment>
		);
	}
}

export default LogoPageFull;
